module.exports = __webpack_public_path__ + "img/charging4.55b671b2.png";